import { render, staticRenderFns } from "./PlayIcon.vue?vue&type=template&id=72b55699&scoped=true"
import script from "./PlayIcon.vue?vue&type=script&lang=js"
export * from "./PlayIcon.vue?vue&type=script&lang=js"
import style0 from "./PlayIcon.vue?vue&type=style&index=0&id=72b55699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b55699",
  null
  
)

export default component.exports